import { z } from 'zod';

export enum StatusEnum {
    Published = 'published',
    Draft = 'draft',
    Archived = 'archived',
}

export const StatusTypeSchema = z.nativeEnum(StatusEnum);
export type StatusType = z.infer<typeof StatusTypeSchema>;